import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LayerControlService {

  active:boolean = false;

  constructor() { }
}
